import { Table } from "antd";
import React from "react";

const AllConfiguration = ({ weldParameters }) => {
  console.log("weldParametersallConf", weldParameters);

  // Find the JOB parameters object in the array
  const jobParameters = Array.isArray(weldParameters)
    ? weldParameters.find((item) => item.Type === "JOB")
    : null;

  console.log("jobParameters", jobParameters);

  // Prepare dataSource for the table
  const dataSource = jobParameters
    ? Object.entries(jobParameters)
        .filter(([key]) => key !== "Type") // Exclude the Type field
        .map(([parameter, value], index) => ({
          key: index.toString(),
          parameter,
          value: value !== null && value !== undefined ? value.toString() : "",
        }))
    : [];

  const columns = [
    {
      title: "",
      dataIndex: "parameter",
      key: "parameter",
      className: "parameter-column",
    },
    {
      title: "",
      dataIndex: "value",
      key: "value",
      className: "value-column",
    },
  ];

  const calcHeight = -150;
  const tableHeight = `calc(${calcHeight}px + 100vh)`;
  return (
    <div
      className="welding-parameters-container"
      style={{
        height: tableHeight,
        position: "relative",
      }}
    >
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        bordered
        className="welding-parameters-table"
        size="middle"
        showHeader={false}
        scroll={{ y: tableHeight }}
      />
    </div>
  );
};

export default AllConfiguration;
